import { cookieProfil } from "../Datalayers/features/cookieProfil";

/**
 * Paramètres de campagne (utm_*).
 *
 * Tout se passe dans le navigateur pour rester compatible avec le cache de page (WP Rocket,
 * nginx) : une page servie depuis le cache n'exécute pas PHP.
 * - à l'arrivée sur une page portant des utm_ : mémorisation en cookie pour 30 jours ;
 * - au rendu d'un formulaire Gravity Forms : les champs cachés marqués data-utm-param
 *   (cf. config/misc/Utm.php) reprennent la valeur du cookie du visiteur, ou restent vides.
 */

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term'];
const COOKIE_DAYS = 30;

const storeUtmParams = (): void => {
    const params = new URLSearchParams(window.location.search);

    UTM_PARAMS.forEach(param => {
        const value = params.get(param)?.trim();
        if (value) {
            cookieProfil.setCookie(param, value, COOKIE_DAYS);
        }
    });
};

/**
 * Les cookies posés par l'ancienne version PHP codent les espaces en « + ». encodeURIComponent
 * code le « + » en %2B : convertir les « + » avant de décoder vaut donc pour les deux formats.
 */
const readUtmCookie = (param: string): string => {
    const raw = document.cookie
        .split('; ')
        .find(cookie => cookie.startsWith(`${param}=`))
        ?.slice(param.length + 1);

    if (!raw) return '';

    try {
        return decodeURIComponent(raw.replace(/\+/g, ' '));
    } catch {
        return '';
    }
};

const fillUtmFields = (): void => {
    document.querySelectorAll<HTMLInputElement>('input[data-utm-param]').forEach(input => {
        const param = input.dataset.utmParam ?? '';
        input.value = UTM_PARAMS.includes(param) ? readUtmCookie(param) : '';
    });
};

export default () => {
    storeUtmParams();
    fillUtmFields();

    // Formulaires AJAX (contact, candidature) : Gravity Forms réaffiche le formulaire.
    document.addEventListener('gform/post_render', fillUtmFields);
};
